module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-10.3092a9ff.png";